import React, { useEffect } from 'react';
import img_2_1 from '../img/earnestroi-careers.webp';
import img_2_2 from '../img/earnestroi-careers-aboutus.webp';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import Aos from 'aos';
import 'aos/dist/aos.css';
import $ from 'jquery';
import { Link } from 'react-router-dom';
import Footern from './Footern';
// import WhatsappChat from './WhatsappChat';
// import { Helmet } from 'react-helmet';

const WeAreHiring = () => {

  useEffect(() => {

    Aos.init({

      disable: function () {
        var maxWidth = 1023;
        return window.innerWidth < maxWidth;
      }

    });


    $(document).ready(function () {
      $(this).scrollTop(0);
    });

  });

  useEffect(() => {
    Aos.init({ duration: 3000 });

  })

  const baseEmail = "career@earnestroi.com";
  const commonBody = "Hi Team, I would like to discuss...";

  return (
    <>
      <section className="bg-main py-0 lg:pb-16">
        <div className="container mx-auto py-10">
          <div className="text-center mb-6 pb-[2px]">
            <span className="border-b-4 border-second text-3xl text-[white] font_primary">
              Positions Available
            </span>
          </div>
          <div className="grid-cols-2 flex flex-col lg:flex-row justify-around">
            <div
              className="py-10 lg:py-0 px-2 w-full lg:w-[40%]"
              data-aos="fade-up"
            >
              <p className="font_primary text-base sm:text-lg mb-4 uppercase text-[white] font_secondary">
                1) Business Development Executive&nbsp;  <span className="inline-flex items-center px-4 py-1.5 rounded-full text-[10px] sm:text-xs font-bold bg-third text-main animate-pulse shadow-[0_0_15px_rgba(var(--third-rgb),0.5)] uppercase tracking-wider border border-third/50">
                  <span className="relative flex h-2 w-2 mr-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-main opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-main"></span>
                  </span>
                  Urgent
                </span>
              </p>


              <p className="text-base sm:text-lg mb-4 text-[white] font_secondary">
                <strong>Position Overview</strong>
              </p>

              <p className="mb-4 text-[white] font_secondary">
                We are looking for a motivated and results-driven <strong>Business Development Executive </strong>with <strong>2+
                years of experience</strong> in <strong>SaaS sales.</strong> The ideal candidate should have experience selling
                software solutions, generating qualified leads, conducting client meetings, and closing deals.
                This is a field sales role focused on acquiring new customers, building strong business
                relationships, and driving revenue growth through our SaaS platform.
              </p>

              <p className="text-base sm:text-lg mb-4 text-[white] font_secondary">
                <strong>Key Responsibilities</strong>
              </p>

              <ul className="mb-4 list-disc pl-6">
                <li className="text-[white] font_secondary">
                  Generate new business opportunities through field visits, cold calling, networking, and
                  referrals.
                </li>
                <li className="text-[white] font_secondary">
                  Identify and connect with business owners, founders, and decision-makers.
                </li>
                <li className="text-[white] font_secondary">
                  Present and demonstrate the company's SaaS platform to prospective clients.
                </li>
                <li className="text-[white] font_secondary">
                  Understand customer requirements and recommend suitable software solutions.
                </li>
                <li className="text-[white] font_secondary">
                  Build and manage a healthy sales pipeline from lead generation to deal closure.
                </li>
                <li className="text-[white] font_secondary">
                  Achieve monthly sales and business development targets.
                </li>
                <li className="text-[white] font_secondary">
                  Maintain strong relationships with clients to encourage repeat business and referrals.
                </li>
                <li className="text-[white] font_secondary">
                  Record and manage sales activities using CRM tools.
                </li>
                <li className="text-[white] font_secondary">
                  Stay updated on market trends, competitor offerings, and customer requirements.
                </li>
              </ul>

              <p className="text-base sm:text-lg mb-4 text-[white] font_secondary">
                <strong>Required Skills & Qualifications</strong>
              </p>

              <ul className="mb-4 list-disc pl-6">
                <li className="text-[white] font_secondary">
                  Bachelor's degree in Business, Marketing, Management, or a related field.
                </li>
                <li className="text-[white] font_secondary">
                  Minimum <strong>2 years of experience</strong> in  <strong> Business Development or B2B SaaS Sales.</strong>
                </li>
                <li className="text-[white] font_secondary">
                  Experience selling SaaS, software, or subscription-based products.
                </li>
                <li className="text-[white] font_secondary">
                  Strong lead generation, prospecting, negotiation, and closing skills.
                </li>
                <li className="text-[white] font_secondary">
                  Excellent communication and presentation skills.
                </li>
                <li className="text-[white] font_secondary">
                  Ability to conduct face-to-face client meetings and product demonstrations.
                </li>
                <li className="text-[white] font_secondary">
                  Self-motivated, target-oriented, and willing to travel for field sales.
                </li>
                <li className="text-[white] font_secondary">
                  Familiarity with CRM software and Microsoft Office.
                </li>
              </ul>

              <p className="text-base sm:text-lg mb-4 text-[white] font_secondary">
                <strong>Job Details</strong>
              </p>

              <ul className="mb-4 list-disc pl-6">
                <li className="text-[white] font_secondary">
                  <strong>Role:</strong> Business Development Executive
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Industry Type:</strong> SaaS / Software / Technology
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Employment Type:</strong> Full-Time, Permanent
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Experience:</strong> 2+ Years
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Location:</strong> Mumbai
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Work Mode:</strong> Field Sales
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Salary:</strong> ₹2,00,000 – ₹3,00,000 CTC per annum
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Incentives:</strong> Attractive performance-based incentives
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Bonus:</strong> Monthly & Quarterly Performance Bonus
                </li>
              </ul>

              <p className="text-base sm:text-lg mb-4 text-[white] font_secondary">
                <strong>Perks & Benefits</strong>
              </p>

              <ul className="mb-4 list-disc pl-6">
                <li className="text-[white] font_secondary">
                  Competitive salary package.
                </li>
                <li className="text-[white] font_secondary">
                  Attractive incentives with excellent earning potential.
                </li>
                <li className="text-[white] font_secondary">
                  Monthly and quarterly performance bonuses.
                </li>
                <li className="text-[white] font_secondary">
                  Travel allowance for official client meetings.
                </li>
                <li className="text-[white] font_secondary">
                  Career growth opportunities based on performance.
                </li>
                <li className="text-[white] font_secondary">
                  Product and sales training.
                </li>
                <li className="text-[white] font_secondary">
                  Opportunity to work with an innovative SaaS platform.
                </li>
                <li className="text-[white] font_secondary">
                  Supportive and growth-focused work environment.
                </li>
              </ul>

              <a
                href={`mailto:${baseEmail}?subject=${encodeURIComponent("Application for Business Development Executive")}&body=${encodeURIComponent(commonBody)}`}
                // href={emailHref}
                className="relative p-2  my-4 md:my-0 border-2 border-[#fff] text-[white] rounded-lg font_primary"
                aria-label="Contact us via email"
                target="_blank"
                rel="noopener noreferrer"
              >
                Apply{" "}
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="text-second pl-4 animate-right_left"
                />
              </a>
            </div>
            <div
              className="py-10 lg:py-0 px-2 w-full lg:w-[40%]"
              data-aos="fade-up"
            >
            

               <p className="font_primary text-base sm:text-lg mb-4 uppercase text-[white] font_secondary">
                2) Business Development Manager&nbsp;  <span className="inline-flex items-center px-4 py-1.5 rounded-full text-[10px] sm:text-xs font-bold bg-third text-main animate-pulse shadow-[0_0_15px_rgba(var(--third-rgb),0.5)] uppercase tracking-wider border border-third/50">
                  <span className="relative flex h-2 w-2 mr-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-main opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-main"></span>
                  </span>
                  Urgent
                </span>
              </p>

              <p className="text-base sm:text-lg mb-4 text-[white] font_secondary">
                <strong>Position Overview</strong>
              </p>

              <p className="mb-4 text-[white] font_secondary">
                We are looking for an experienced and performance-driven <strong> Business Development Manager </strong>
                with <strong>3+ years of experience </strong> in <strong>SaaS Sales.</strong> The ideal candidate should have a proven track
                record of driving revenue, managing a sales team, and closing business opportunities. This is a
                field sales leadership role focused on expanding our customer base, generating new business,
                mentoring the sales team, and achieving overall sales targets.
              </p>

              <p className="text-base sm:text-lg mb-4 text-[white] font_secondary">
                <strong>Key Responsibilities</strong>
              </p>

              <ul className="mb-4 list-disc pl-6">
                <li className="text-[white] font_secondary">
                  Lead, manage, and motivate the Business Development team to achieve sales targets.
                </li>
                <li className="text-[white] font_secondary">
                  Generate new business opportunities through field visits, networking, referrals, and
                  strategic prospecting.
                </li>
                <li className="text-[white] font_secondary">
                  Meet business owners and decision-makers to present and demonstrate the company's
                  SaaS platform.
                </li>
                <li className="text-[white] font_secondary">
                  Drive the complete sales cycle from lead generation to successful deal closure.
                </li>
                <li className="text-[white] font_secondary">
                  Monitor team performance, provide coaching, and ensure sales targets are consistently
                  achieved.
                </li>
                <li className="text-[white] font_secondary">
                  Build and maintain a strong sales pipeline for both individual and team opportunities.
                </li>
                <li className="text-[white] font_secondary">
                  Develop long-term client relationships to maximize business growth and referrals.
                </li>
                <li className="text-[white] font_secondary">
                  Track sales activities, prepare reports, and maintain CRM records.
                </li>
                <li className="text-[white] font_secondary">
                  Stay updated on market trends, customer needs, and competitor activities.
                </li>
              </ul>

              <p className="text-base sm:text-lg mb-4 text-[white] font_secondary">
                <strong>Required Skills & Qualifications</strong>
              </p>

              <ul className="mb-4 list-disc pl-6">
                <li className="text-[white] font_secondary">
                  Bachelor's degree in Business, Marketing, Management, or a related field.
                </li>
                <li className="text-[white] font_secondary">
                  Minimum <strong>3+ years of experience</strong> in <strong>Business Development or B2B SaaS Sales</strong>.
                </li>
                <li className="text-[white] font_secondary">
                  Experience leading and managing a sales team.
                </li>
                <li className="text-[white] font_secondary">
                  Strong experience in SaaS, software, or subscription-based product sales.
                </li>
                <li className="text-[white] font_secondary">
                  Excellent leadership, communication, negotiation, and presentation skills.
                </li>
                <li className="text-[white] font_secondary">
                  Proven ability to achieve and exceed sales targets.
                </li>
                <li className="text-[white] font_secondary">
                  Strong lead generation, relationship-building, and closing skills.
                </li>
                <li className="text-[white] font_secondary">
                  Self-motivated, target-oriented, and willing to travel for field sales.
                </li>
                <li className="text-[white] font_secondary">
                  Familiarity with CRM software and Microsoft Office.
                </li>
              </ul>

              <p className="text-base sm:text-lg mb-4 text-[white] font_secondary">
                <strong>Job Details</strong>
              </p>

              <ul className="mb-4 list-disc pl-6">
                <li className="text-[white] font_secondary">
                  <strong>Role: </strong>Business Development Manager
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Industry Type: </strong>SaaS / Software / Technology
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Department: </strong>Sales & Business Development
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Employment Type: </strong>Full-Time, Permanent
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Experience: </strong>3+ Years
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Location: </strong>Mumbai
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Work Mode: </strong>Field Sales, Client Meetings & Virtual Sales
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Salary: </strong>₹4,00,000 – ₹5,00,000 CTC per annum
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Incentives: </strong>Attractive performance-based incentives
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Performance Bonus: </strong>Monthly & Quarterly
                </li>
                <li className="text-[white] font_secondary">
                  <strong>Reporting To: </strong>Director / Business Head
                </li>

              </ul>

              <p className="text-base sm:text-lg mb-4 text-[white] font_secondary">
                <strong>Perks & Benefits</strong>
              </p>

              <ul className="mb-4 list-disc pl-6">
                <li className="text-[white] font_secondary">
                  Competitive salary package.
                </li>
                <li className="text-[white] font_secondary">
                  Attractive incentives with excellent earning potential.
                </li>
                <li className="text-[white] font_secondary">
                  Monthly and quarterly performance bonuses.
                </li>
                <li className="text-[white] font_secondary">
                  Leadership and career growth opportunities.
                </li>
                <li className="text-[white] font_secondary">
                  Travel allowance for official client meetings.
                </li>
                <li className="text-[white] font_secondary">
                  Product, leadership, and sales training.
                </li>
                <li className="text-[white] font_secondary">
                  Opportunity to work with an innovative SaaS platform.
                </li>
                <li className="text-[white] font_secondary">
                  Performance recognition and rewards.
                </li>
                <li className="text-[white] font_secondary">
                  Supportive and growth-focused work environment.
                </li>

              </ul>
              <a
                href={`mailto:${baseEmail}?subject=${encodeURIComponent("Application for Business Development Manager")}&body=${encodeURIComponent(commonBody)}`}
                // href={emailHref}
                className="relative p-2  my-4 md:my-0 border-2 border-[#fff] text-[white] rounded-lg font_primary"
                aria-label="Contact us via email"
                target="_blank"
                rel="noopener noreferrer"
              >
                Apply{" "}
                <FontAwesomeIcon
                  icon={faArrowRight}
                  className="text-second pl-4 animate-right_left"
                />
              </a>

            </div>
          </div>
        </div>
      </section>
      <section className="mt-[3.5rem] lg:mt-[4rem] py-10">

        <div className="container mx-auto">

        </div>
        <div className="container mx-auto py-1">
          <div className="grid-cols-2 flex flex-col lg:flex-row justify-center items-center">
            <div className="px-2 w-full lg:w-1/2">
              <div className="border-b-2 border-second w-full mb-4 pb-[2px]">
                <span className="border-b-2 border-second text-3xl text-second font_primary">
                  Are You ...
                </span>
              </div>
              <p
                className="text-base sm:text-lg mb-4 font_secondary"
                data-aos="fade-left"
              >
                An aspiring creative, looking for an unorthodox digital
                marketing agency? An agency where working remotely is the norm
                and grueling office small talk is the exception.
              </p>
              <p
                className="text-base sm:text-lg mb-4 font_secondary"
                data-aos="fade-left"
              >
                Our team at Earnestroi is ever-expanding and we are constantly
                on the lookout for talented and driven individuals, with a
                wicked sense of humor, seeking to expand their skill set.
              </p>
              <p
                className="text-base sm:text-lg mb-4 font_secondary"
                data-aos="fade-left"
              >
                Whether you are a marketer, graphic designer, content creator,
                copywriter or overall creative genius, we at Earnestroi will
                find an adaptive role that will be a perfect fit for you.{" "}
              </p>
            </div>
            <div className="px-2 w-full lg:w-1/2">
              <img src={img_2_2} alt="img_2_2" className="mx-auto block" />
            </div>
          </div>
        </div>
      </section>
      <Footern />
    </>
  );
}

export default WeAreHiring;